import React from 'react';
import {
  IconAISiteBuilder, IconAIWordPress, IconBriefcase, IconGlasses, IconHeart, IconSmile, Link,
} from 'gatorcomponents';
import { OTHER_TOOLS_OPTION_IDS } from '@/components/OnboardingHandlerComponents/OtherToolsSuccess/OtherToolsSuccess.enum';
import { CREATE_SITE_AGENT_TABS, CREATE_SITE_TABS } from '@/components/OnboardingHandlerComponents/AiBuilderCreateSite/AiBuilderCreateSite.enum';
import { TEMPLATE_CATEGORIES } from '@/components/OnboardingHandlerComponents/AiBuilderWithTemplate/AiBulderWithTemplate.enum';
import { STEPS } from '@/pages/sites/SitesWizardHandler/SitesWizardHandler.enum';
import sitebuilderESImage from '@/media/onboarding/aiBuilder/sitebuilder-ai-es.png';
import wordpressESImage from '@/media/onboarding/aiWordpress/wordpress-ai-es.png';
import { SEGMENTS_OPTIONS_LIST_ES } from './segments.es';

export default {
  title: 'Onboarding title',
  goBackButtonLabel: 'Volver',
  continueButtonLabel: 'Continuar',
  sendFileButtonLabel: 'Enviar archivo',
  chooseSiteOption: {
    title: 'Muestra tu empresa al mundo. Elige cómo <strong>crear tu sitio web:</strong>',
    options: [
      {
        id: 0,
        iconTitle: <IconAISiteBuilder color="lowDark" size="md" />,
        title: 'Creador de sitios con IA',
        description: 'Deja que la IA cree tu sitio con los datos de tu página de Google, o dile cómo quieres tu sitio. Si quieres, elige una plantilla lista.',
        cta: { label: 'Usar Creador de Sitios con IA', action: () => { } },
        recommended: 'Recomendado',
        subtitle: 'Para iniciantes',
        footerLabel: 'Rápido, fácil y sin saber de tecnología.',
        image: {
          src: sitebuilderESImage,
          alt: 'Creador de sitios con IA',
        },
      },
      {
        id: 1,
        iconTitle: <IconAIWordPress color="lowDark" size="md" />,
        title: 'Crear sitio con WordPress',
        description: 'Tú eliges: deja que la IA haga todo y edítalo después si quieres, o créalo tú con plugins como Elementor y Beaver. Control total para ti.',
        cta: { label: 'Usar WordPress con IA', action: () => { } },
        subtitle: 'Para quien ya conoce WordPress',
        footerLabel: '¿Prefieres sin IA?',
        ctaFooter: { label: 'Crear solo en WordPress', action: () => { } },
        image: {
          src: wordpressESImage,
          alt: 'Crear sitio con WordPress',
        },
      },
    ],
    advancedModeModal: {
      title: '¿Quieres continuar en el Modo Avanzado?',
      description: 'Esta opción está indicada para quienes tienen conocimientos técnicos. <br/><br/> Tú serás responsable de toda la implementación (HTML/CSS/JS, frameworks e integraciones), build y ajustes finos sin ayuda de la IA.',
      exitButtonLabel: 'Cancelar',
      confirmButtonLabel: 'Sí, crear en el Modo Avanzado',
    },
    normalModeModal: {
      title: '¿Estás seguro de que quieres crear manualmente en WordPress?',
      description: 'Esta opción está recomendada para quienes ya tienen experiencia o conocimientos técnicos en WordPress. <br/><br/> Tú harás todas las configuraciones y personalizaciones por tu cuenta, sin ayuda de la IA.',
      exitButtonLabel: 'Cancelar',
      confirmButtonLabel: 'Sí, crear manualmente',
    },
    haveExperienceLabel: '¿Ya tienes experiencia técnica y prefieres usar cPanel, FTP u otras plataformas?',
    ctaAdvancedMode: { label: 'Crear en modo avanzado', action: () => { } },
  },
  siteAlreadyExists: {
    title: 'Identificamos que ya tienes un sitio web creado.',
    description: () => (
      <p>
        Si continúas, tu
        {' '}
        <b>tu sitio actual será eliminado</b>
        {' '}
        para dar lugar al nuevo.
      </p>
    ),
    bulletPoints: {
      title: '¿Qué debo hacer?',
      list: [
        'Si deseas continuar con los cambios, simplemente haz clic en Continuar',
        'Si prefieres mantener tu sitio actual, regresa y elige otra opción',
      ],
    },
    checkboxLabel: 'Soy consciente y quiero continuar de todos modos',
    continueButtonLabel: 'Continuar',
    goBackButtonLabel: 'Regressar',
  },
  wordPress: {
    title: 'Sitio WordPress',
    subtitle: 'con Inteligencia Artificial',
    description: 'Cree un nombre de usuario y una contraseña para su cuenta de WordPress',
    userLabel: 'Usuario',
    passwordLabel: 'Contraseña',
    userNameError: 'Utilice un mínimo de 6 caracteres sin caracteres especiales',
    passwordError: 'Utilice un mínimo de 8 caracteres, con mayúsculas, minúsculas, números y caracter especial',
    wpIaSuccess: isUsingTempDomain => ({
      title: '¡Ya está todo listo!',
      subtitle: isUsingTempDomain
        ? 'Su dominio temporal y cuenta WordPress se han creado con éxito'
        : 'Ahora puede empezar a crear y personalizar su sitio web a su manera sin necesidad de código.',
      description: 'Cree un sitio web en minutos con apoyo de la Inteligencia Artificial',
      infoList: [
        'Personalice fácilmente el diseño y el contenido',
        'Edite y publique sin complicaciones',
      ],
    }),
    wpNormalSuccess: isUsingTempDomain => ({
      title: '¡Ya está todo listo!',
      subtitle: isUsingTempDomain
        ? 'Su dominio temporal y cuenta WordPress se han creado con éxito'
        : 'Ahora puede empezar a crear y personalizar su sitio web a su manera sin necesidad de código.',
      description: 'Cree un sitio web con WordPress',
      infoList: [
        'Creación intuitiva sin codificación, con temas y plugins personalizables',
        'Recursos optimizados para un mejor ranking y velocidad del sitio',
      ],
    }),
    leftButtonLabel: 'Portal del Cliente',
    rightButtonLabel: 'Empezar ahora',
  },
  domainRegistered: {
    title: 'Elija un dominio para su sitio web',
    description: 'El dominio es la dirección de tu sitio web en internet (como misitio.com)',
    placeholder: 'Nombre de dominio',
    alertTitle: '¡Todo bien!',
    alertDescription: 'Su sitio web se configurará con este dominio. Puede ajustarlo después si lo necesita.',
    success: {
      title: '¡Ya está todo listo!',
      description: 'Ahora puede empezar a crear y personalizar su sitio web a su manera sin necesidad de código.',
      infoList: [
        'Personalice su sitio web con diseños listos para usar y edite con pocos clics.',
        'Añada su contenido y vea cómo su sitio toma forma en tiempo real.',
        '¡Publique cuando esté listo y comparta su sitio web con el mundo!',
      ],
      leftButtonLabel: 'Portal del Cliente',
      rightButtonLabel: 'Empezar ahora',
    },
    selectDomainLabel: 'Selecciona Dominio o Subdominio',
    wantToUseAnotherDomain: 'Quiero usar otro dominio o subdomínio',
    usingTempDomain: {
      title: 'Dominio Temporal',
      description: 'Tendrá una dirección temporal para acceder y editar su sitio web ahora',
      tempDomainInfo: [
        'Un dominio propio lleva más tiempo y se puede ser definido cuando el sitio esté listo',
        'El dominio temporal se generará y mostrará en el paso final.',
      ],
      understandTheDifference: (
        <Link
          target="_blank"
          href="https://soporte.hostgator.mx/hc/es-419/articles/38718464271891--Qu%C3%A9-es-y-c%C3%B3mo-funciona-el-dominio-temporal#diferencias"
          text="Entienda las diferencias entre un dominio temporal y uno proprio"
        />
      ),
    },
    inputErrors: {
      startOrEndWithHyphen: 'El dominio no puede comenzar o terminar con un guion',
      twoHyphensInARow: 'El dominio no puede tener dos guiones seguidos',
      lessThanThreeCharacters: 'Utilice 3 caracteres o más para su dominio',
      hasSpecialChars: 'El dominio no puede tener caracteres especiales, excepto el guion',
    },
  },
  otherTools: {
    title: '¡Ya está todo listo!',
    description: '¡Elija el camino que tenga más sentido para usted y comience a construir su sitio web!',
    options: [
      { title: 'Ingresar al cPanel', description: 'Administre su alojamiento, configure la base de datos y los correos electrónicos, y acceda a FTP para enviar archivos al servidor.', id: OTHER_TOOLS_OPTION_IDS.CPANEL },
      { title: 'Explorar Softaculous', description: 'Instale herramientas para su sitio web en pocos clics, sin configuraciones manuales.', id: OTHER_TOOLS_OPTION_IDS.SOFTACULOUS },
      { title: 'Datos de acceso FTP', description: 'Envie archivos directamente al servidor. También puede encontrar estos datos en cPanel en el Portal HostGator.', id: OTHER_TOOLS_OPTION_IDS.FTP },
    ],
    leftButtonLabel: 'Volver',
    rightButtonLabel: 'Continuar',
  },
  selectPlanList: {
    title: 'Escoge uno de los planes activos abajo',
    domainText: 'Dominio Principal:',
  },
  externalDomain: {
    title: domain => `El dominio “${domain}” fue registrado con otra empresa`,
    subtitle: '¿Necesita ayuda para conectar su sitio web?',
    info: (
      <>
        Para vincularlo correctamente apuntar las DNS a nuestro hosting.
        <a
          target="_blank"
          rel="noreferrer"
          href="https://soporte.hostgator.mx/hc/es-419/articles/28438767552147-C%C3%B3mo-configurar-el-dominio-cambiar-DNS-en-otro-proveedor-GoDaddy-Web-Empresa-Colombia-Hosting-Neubox-NIC-Chile"
        >
          Descubra cómo en la Central de ayuda.
        </a>
      </>
    ),
    continueButtonLabel: 'Portal del Cliente',
    startNow: 'Comenzar ahora',
  },
  configuredDnsSuccess: {
    title: '¡Listo! Su dominio se está configurando con éxito',
    description: 'Espere hasta 2 horas para que el sitio se active con el nuevo dominio',
    infoList: [
      'Después de la publicación, espere a que el sitio se propague antes de seguir adelante con la herramienta de creación seleccionada.',
    ],
    continueButtonLabel: 'Portal del Cliente',
  },
  domainNotRegistered: {
    title: domain => `O domínio “${domain}” está disponível para compra`,
    subtitle: 'Caso prefira, pode continuar a configuração agora com um domínio temporário.',
    list: [
      'O domínio temporário permite você construir seu site sem precisar configurar um domínio próprio',
      'Quando seu site estiver completo você poderá alterar para um domínio próprio no Portal do Cliente',
    ],
  },
  chooseWpMigrationStep: {
    title: 'Defina cómo desea proceder',
    options: [
      { title: 'Crear Sitio', description: 'Elija la herramienta de creación de sitios web que mejor se adapte a su proyecto y empiece a construirlo de inmediato.', cta: { label: 'Crear Sitio', action: () => { } } },
      { title: 'Migrar Sitio WordPress', description: 'Migre su sitio de WordPress a nuestros servidores cargando los archivos de copia de seguridad o proporcionando los datos de acceso a través de FTP.', cta: { label: 'Migrar Sitio WordPress', action: () => { } } },
    ],
    continueLater: 'Crear o migrar sitio después',
  },
  buyPlan: {
    title: 'Necesitas un plan superior para continuar',
    subtitle: 'Parece que tu plan actual no permite agregar nuevos sitios web ¡Pero no te preocupes, es fácil de solucionar!',
    description: '¿Cómo continuar?',
    list: [
      'Haz un upgrade en tu plan para habilitar la creación de nuevos sitios web',
      'Después, reinicia el proceso para configurar tu sitio web',
    ],
  },
  chooseMigrationOption: {
    title: 'Migrar sitio WordPress',
    description: 'Elija la mejor manera de traer su sitio web para aquí:',
    filesMigration: {
      id: 'files',
      title: 'Migrar con archivo',
      description: '¿Tiene una copia de seguridad de su sitio web? Por favor, cargue el archivo para comenzar la migración.',
      tag: 'Recomendado',
    },
    ftpMigration: {
      id: 'ftp',
      title: 'Migrar con datos FTP',
      description: '¿Prefiere migrar directamente desde el servidor? Introduzca los datos de su FTP y nosotros nos encargamos del resto.',
    },
  },
  ftpMigrationForm: {
    title: 'Migrar sitio de WordPress con datos FTP',
    description: 'Envíe las informaciones FTP para migrar un sitio WordPress',
    form: {
      userName: 'Usuario FTP',
      password: 'Contraseña FTP',
      databaseName: 'Nombre de la base de datos de destino',
      sourcePath: 'Directorio del sitio de origen',
      sourceIp: 'IP o nombre del servidor de origen',
      sourceDomain: 'Dominio de origen',
      destinationPath: 'Directorio de destino',
      sourcePort: 'Puerta del servidor de origen',
    },
    questions: (
      <p>
        <span>¿Dudas?</span>
        {' '}
        <a href="https://soporte.hostgator.mx/hc/es-419/articles/28438358322323" target="_blank" rel="noreferrer">
          Acceda al material sobre cómo saber los datos FTP
        </a>
      </p>
    ),
    toast: {
      title: 'Error al enviar datos FTP',
      info: 'Hubo un problema al enviar las informaciones de FTP. Por favor, revise los datos introducidos e inténtelo de nuevo.',
    },
    required: 'Obrigatorio',
    optional: 'Opcional',
  },
  filesMigration: {
    title: 'Migrar con archivos',
    description: (
      <>
        <span>
          {'Envíe un archivo '}
          <strong>.zip</strong>
          {' que contenga todos los archivos de su sitio de WordPress.'}
        </span>
        <span>
          {'Envíe también el archivo '}
          <strong>.sql</strong>
          {' de la base de datos correspondiente.'}
        </span>
      </>
    ),
    doubt: (
      <>
        {'¿Dudas? '}
        <Link
          text="Acceda al material sobre cómo migrar con un archivo."
          href="https://soporte.hostgator.mx/hc/es-419/articles/35217888599059"
          target="_blank"
        />
      </>
    ),
    processLabel: 'Procesando',
    storeSpace: 'Almacenamiento',
    dragText: 'Haga clic para seleccionar los archivos o arrástrelos y suéltelos aquí',
    migrationError: {
      title: type => `Error al enviar el archivo .${type}`,
      description: 'Verifique si los datos ingresados son correctos e inténtelo nuevamente. Si necesita reemplazar el archivo, elimine el anterior haciendo clic en la "x".',
    },
    fileSizeError: {
      title: 'Error de envío de archivos',
      description: size => `El archivo supera el límite de ${size}GB permitido. Por favor, envíe archivos más pequeños. Si necesita reemplazar el archivo, elimine el archivo anterior haciendo clic en la "X".`,
    },
  },
  migrationSuccess: {
    title: '¡Migración en curso!',
    description: 'Estamos procesando la migración de su sitio',
    infoList: [
      <>
        Una vez que se complete la migración,
        {' '}
        <b>recibirá una notificación en &quot;Mis avisos&quot;.</b>
        {' '}
        Mientras tanto, puede regresar al Portal del Cliente.
      </>,
    ],
    continueButtonLabel: 'Portal del Cliente',
  },
  aiBuilderCreateSite: {
    loadingTitles: [
      'Estoy creando tu sitio',
      'Buscando el mejor estilo',
      'Ahora eligiendo imágenes y textos',
      'Un segundo, ¡esto está quedando increíble!',
    ],
    steps: {
      [CREATE_SITE_TABS.NAME]: {
        promoBannerTitle: (
          <>
            {'Crea '}
            <strong>sitios increíbles</strong>
            {' con IA'}
          </>
        ),
        label: 'Nombre del sitio',
        title: 'Hola, ¡te ayudaré a crear tu sitio web!',
        inputHeadText: '¿Cuál es el nombre del sitio? Puede ser el de tu empresa o marca.',
        inputPlaceholder: 'Escribe el nombre',
        buttonLabel: 'Siguiente paso',
      },
      [CREATE_SITE_TABS.SEGMENT]: {
        promoBannerTitle: (
          <>
            {'Tu '}
            <strong>negocio online</strong>
            {' con IA'}
          </>
        ),
        label: 'Rubro',
        title: 'Ahora cuéntame, ¿cuál es el tipo de negocio? Esto es lo que tú haces o vendes.',
        inputHeadText: 'Elige un rubro para tu sitio.',
        inputPlaceholder: 'Escribe o elige un rubro',
        buttonLabel: 'Siguiente paso',
        optionsList: SEGMENTS_OPTIONS_LIST_ES,
      },
      [CREATE_SITE_TABS.INFOS]: {
        promoBannerTitle: (
          <>
            {'Muéstrale al '}
            <strong>mundo</strong>
            {' tu sitio'}
          </>
        ),
        label: 'Informaciones',
        title: 'Y para terminar, ¡cuéntame sobre tu empresa!',
        subtitle: 'Habla sobre tu negocio, tu marca o servicio',
        subtitleTooltip: 'Ejemplo: “Tengo un restaurante de comida saludable, especializado en ensaladas, para personas que buscan una alimentación ligera. Quiero un sitio web con un estilo moderno y colorido, que muestre el menú y tenga opción para hacer pedidos online.”',
        textAreaLabel: 'Describe lo que haces, para quién es tu sitio...',
        contactInfos: 'Informaciones de contacto',
        contactInfosDescription: 'Aparecerá en tu sitio para que las personas puedan comunicarse contigo.',
        optional: '(opcional)',
        telephonePlaceholder: 'Escribe tu número de teléfono',
        emailPlaceholder: 'Escribe tu correo electrónico',
        buttonLabel: 'Crear mi sitio ahora',
        emailTooltip: 'Ingresa un correo electrónico válido para continuar',
        errors: {
          genericError: 'Completa correctamente todos los campos',
          emailError: 'Ingresa un correo electrónico válido',
          telephoneError: 'Ingresa un número de teléfono válido',
        },
      },
    },
  },
  aiBuilderMyBusiness: {
    loadingTitles: [
      'Estoy creando tu sitio',
      'Buscando el mejor estilo',
      'Ahora eligiendo imágenes y textos',
      'Un segundo, ¡esto está quedando increíble!',
    ],
    promoBannerTitle: (
      <>
        {'Crea sitios increíbles '}
        <strong>{'con IA '}</strong>
      </>
    ),
    content: {
      loadingTitles: [
        'Estoy creando tu sitio',
        'Buscando el mejor estilo',
        'Ahora eligiendo imágenes y textos',
        'Un segundo, ¡esto está quedando increíble!',
      ],
      label: 'Nombre del sitio',
      title: '¡Hola, soy Gator, la inteligencia artificial que va a crear tu sitio!',
      inputLabel: 'Necesito localizar los datos de tu empresa',
      inputPlaceholder: 'Nombre de la empresa',
      buttonLabel: 'Crea mi sitio',
      notFoundCompany: {
        text: '¿No encontraste tu empresa? ',
        linkText: 'Vuelve y elige otra opción',
      },
    },
  },
  aiBuilderWithTemplate: {
    title: (
      <>
        Elige una
        <strong>{' plantilla '}</strong>
        de sitio web listo
      </>
    ),
    categoriesList: [
      { value: TEMPLATE_CATEGORIES.ALL, label: 'Todos' },
      { value: TEMPLATE_CATEGORIES.LAYOUTS, label: 'Modelos' },
      { value: TEMPLATE_CATEGORIES.FREE, label: 'Página de ventas' },
      { value: TEMPLATE_CATEGORIES.BUSINESS, label: 'Negocios' },
      { value: TEMPLATE_CATEGORIES.EDUCATION, label: 'Cursos' },
      { value: TEMPLATE_CATEGORIES.FOOD, label: 'Comidas' },
      { value: TEMPLATE_CATEGORIES.ART_MUSIC, label: 'Arte y Música' },
      { value: TEMPLATE_CATEGORIES.PORTFOLIO, label: 'Portafolios' },
      { value: TEMPLATE_CATEGORIES.SPORT, label: 'Deporte y salud' },
      { value: TEMPLATE_CATEGORIES.TRAVEL, label: 'Viajes' },
      { value: TEMPLATE_CATEGORIES.SHOP, label: 'Tienda' },
    ],
    openTemplateButtonLabel: 'Crear con esta plantilla',
    openPreviewButtonLabel: 'Mostrar vista previa',
    loadingTitles: [
      'Estoy creando tu sitio',
      'Buscando el mejor estilo',
      'Ahora eligiendo imágenes y textos',
      'Un segundo, ¡esto está quedando increíble!',
    ],
    loadingDescription: 'Espera unos segundos para completar el proceso',

    continueWithTemplateModal: {
      title: '¿Quieres continuar con esta plantilla o prefieres elegir otra?',
      description: 'Si decides cambiar después, tendrás que eliminar la plantilla elegida y todo el contenido creado se borrará. Después de seleccionar una plantilla de sitio, se guardará automáticamente en tu hosting.',
      changeTemplateButtonLabel: 'Buscar otra',
      continueButtonLabel: 'Quiero esta plantilla',
    },
    genericError: {
      title: (
        <>
          Ocurrió un error al cargar los modelos de sitio.
          {' '}
          <br />
          Si el problema continúa, intenta nuevamente más tarde.
        </>
      ),
      buttonLabel: 'Intentar nuevamente',
    },
  },

  genericErrorTitle: 'Algo salió mal',
  genericErrorInfo: 'Por favor, inténtelo de nuevo más tarde',
  useTempDomain: 'Usar um domínio temporário',
  useOwnedDomain: 'Usar su dominio propio',
  siteBuilderV2: {
    topBannerTitle: (
      <>
        Tener un sitio web es
        {' '}
        <strong>más fácil</strong>
        {' '}
        de lo que imaginas
      </>
    ),
    title: '¿Cómo quieres crear tu sitio?',
    subtitle: '¡No pasa nada si cambias de opinión! Si quieres, puedes volver después y elegir otra opción. Elige una opción:',
    ctaContinue: 'Continuar',
    cardsList: {
      [STEPS.IA_BUILDER_MY_BUSINESS]: {
        title: 'Con IA y los datos de mi empresa',
        desc: 'Usa la página de tu empresa en Google. Nuestra IA toma esas informaciones para crear tu sitio en minutos.',
      },
      [STEPS.IA_BUILDER_CREATE_SITE]: {
        title: 'Con la IA creando todo',
        desc: 'Cuéntale todo a la IA: quién es tu público, qué haces o qué vendes. Ella crea tu sitio y tú puedes cambiar lo que quieras después.',
      },
      [STEPS.IA_BUILDER_WITH_TEMPLATE]: {
        title: 'Con una plantilla de sitios lista',
        desc: 'Hay más de 200 plantillas de sitios listas para usar. Una más linda que la otra. Encuentra tu estilo, personaliza y modifica lo que necesites.',
      },
    },
    exitConfirmModal: {
      title: '¿Estás seguro de que quieres salir del Creador de sitios con IA?',
      description: 'Si sales ahora, se perderán todos los cambios realizados y tendrás que empezar desde cero.',
      exitButtonLabel: 'Quiero salir',
      cancelButtonLabel: 'Cancelar',
    },
    factoryAgent: {
      siteCreated: {
        title: '¡Misión cumplida: tu sitio ya está listo!',
        description: 'Mira como ficou tu sitio web. Cambia lo que quieras: contenido, colores, textos y mucho más en editar sitio. Después, empieza a atraer clientes y generar resultados.',
        button: 'Editar sitio',
      },
      agentBlock: {
        title: '¡Acabas de ganar un agente de atención para tu sitio! 🎉',
        subtitle: 'Crea tu agente para atender a tus clientes rápido y fácil.',
        benefits: {
          customize: 'Personaliza y humaniza tu asistente',
          integrateBussiness: 'Integra la información de tu negocio',
          integrateSite: 'Integra el asistente en tu sitio',
          easyCreate: 'Fácil creación en pocos clics sin código',
        },
        button: 'Quiero mi agente',
      },
    },
    aiBuilderCreateSiteAgent: {
      steps: {
        [CREATE_SITE_AGENT_TABS.NAME_SEGMENT]: {
          promoBannerTitle: (
            <>
              {'Tu '}
              <strong>negocio online</strong>
              {' con IA'}
            </>
          ),
          title: '¿Cuál es el nombre y el segmento de tu negocio?',
          subtitle: 'Estas informaciones nos ayuda a construir un sitio alineado con tu negocio, listo para atraer clientes y generar resultados.',
          inputNameHeadText: 'Puede ser el nombre de tu empresa o marca.',
          inputNamePlaceholder: 'Escribe el nombre',
          inputSegmentHeadText: 'Elige el segmento de tu negocio',
          inputSegmentPlaceholder: 'Escribe el segmento',
          buttonLabel: 'Siguiente paso',
          optionsList: SEGMENTS_OPTIONS_LIST_ES,
        },
        [CREATE_SITE_AGENT_TABS.INFOS]: {
          promoBannerTitle: (
            <>
              {'Tu '}
              <strong>agente trabaja</strong>
              {' por ti'}
            </>
          ),
          title: '¿Quieres el mejor sitio web y agente? Cuéntame sobre tu negocio',
          inputDescriptionHeadText: 'Cuéntanos sobre tus servicios, productos, horarios de atención, redes sociales, etc...',
          inputDescriptionPlaceholder: 'Escribe tu texto aquí',
          textRemainingCharactersLabel: 'Caracteres restantes',
          buttonImproveDescription: 'Mejorar mi texto con IA',
          buttonDescriptionExample: 'Consultar cómo completar',
          descriptionExample: (
            <>
              Ofrecemos
              {' '}
              <span>(servicios y productos)</span>
              {' '}
              diseñados para
              {' '}
              <span>(público objetivo)</span>
              .
              <br />
              Nuestra atención es
              {' '}
              <span>(días y horarios)</span>
              {' '}
              y estamos ubicados en
              {' '}
              <span>(dirección física, si aplica)</span>
              .
              <br />
              Estos son nuestros
              {' '}
              <span>(links a redes sociales)</span>
              .
            </>
          ),
          contactInfos: 'Contactos',
          contactInfosDescription: 'Aparecerán en tu sitio para que los clientes puedan ponerse en contacto contigo.',
          optional: '(opcional)',
          telephonePlaceholder: 'Escribe tu número de teléfono',
          emailPlaceholder: 'Escribe tu correo electrónico',
          toneOfVoiceLabel: 'Elige cómo hablará tu agente',
          toneOfVoiceTooltip: (
            <>
              <strong>Tono de voz</strong>
              {' '}
              refleja cómo tu agente se comunicará con tu cliente. De qué forma quieres que sea representado por tu empresa.
            </>
          ),
          toneOfVoiceDescription: '¿Cómo te gustaría que fuera la conversación con tus clientes?',
          toneOfVoiceOptionsList: [
            {
              value: 'professional',
              label: 'Profesional',
              icon: color => <IconBriefcase size="md" color={color} />,
            },
            {
              value: 'friendly',
              label: 'Amigable',
              icon: color => <IconHeart size="md" color={color} />,
            },
            {
              value: 'informal',
              label: 'Informal',
              icon: color => <IconSmile size="md" color={color} />,
            },
            {
              value: 'technical',
              label: 'Técnico',
              icon: color => <IconGlasses size="md" color={color} />,
            },
          ],
          buttonLabel: 'Siguiente paso',
          emailTooltip: 'Ingresa un correo electrónico válido para continuar',
          errors: {
            genericError: 'Completa correctamente todos los campos',
            emailError: 'Ingresa un correo electrónico válido',
            telephoneError: 'Ingresa un número de teléfono válido',
          },
        },
      },
    },
  },
  agentWelcome: {
    presentation: 'Presentación del Agente',
    badge: 'Un regalo para ti',
    title: '¡Acabas de ganar un Agente de IA para tu sitio web y WhatsApp!',
    description: '¡Vamos a crear tu sitio y tu agente en pocos pasos!',
    benefits: [
      'Si el cliente llamó, la IA ya ha respondido',
      'Menos abandono, por responder rápido',
      'Más respuestas, más clientes, más ganancias',
    ],
    button: 'Crear mi sitio y agente',
  },
  sitebuilderAgentSuccess: {
    title: '¡Misión cumplida! ¡Ahora tienes un sitio web y un Agente!',
    siteBox: {
      title: 'Tu sitio ya está listo',
      description:
        'Mira como quedó tu sitio web. Cambia lo que quieras: contenido, colores, textos y mucho más en editar sitio. Después, empieza a atraer clientes y generar resultados.',
      button: 'Editar sitio',
    },
    agentBox: {
      title: 'Tu agente ya puede atender',
      description:
        'Tu agente ya está activo en tu sitio para atender a tus clientes. Para personalizar el nombre, contenido y reglas, accede a “Editar agente”.',
      agentPolicy: (
        <>
          {'Al mantener el agente activo, aceptas la '}
          <Link
            href="https://soporte.hostgator.mx/hc/es-419/articles/43876833596179"
            target="_blank"
            text="política de uso"
          />
          {' del producto.'}
        </>
      ),
      agentActive: 'Agente activo',
      button: 'Editar agente',
    },
  },
  sitebuilderPreview: {
    tooltips: {
      computer: 'Computadora',
      tablet: 'Tableta',
      mobile: 'Teléfono móvil',
    },
    ctaButtons: {
      generateNewSite: 'Generar nuevo sitio',
      useThisSite: 'Usar este sitio',
    },
    loadingTitles: [
      'Estoy creando tu sitio',
      'Buscando el mejor estilo',
      'Ahora eligiendo imágenes y textos',
      'Un segundo, ¡esto está quedando increíble!',
    ],
    loadingTitlesPublish: [
      'Iniciando la publicación de tu sitio...',
      'Garantiendo la mejor velocidad para tus clientes.',
      'Conectando tu empresa al mundo digital.',
      '¡Todo listo! Tu sitio ya está en línea.',
    ],
  },
};
